
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import useLanguage from "../../../../../hooks/useLanguage";


export default function LoginOrder({ statusLogin, setStatusLogin }) {

    const [email, setEmail] = useState("")
    const [orderNumber, setOrderNumber] = useState("")
    const [platform, setPlatform] = useState("")
    const [userToken, setUserToken] = useState("")
    const [loginText, setLoginText] = useState("")
    const dispatch = useDispatch();
    const orders = useSelector((state) => state.reducerLoginOrder);
    const params = useParams();

    const { language, t } = useLanguage();

    const API_LOGIN_TEXT_URL = `${process.env.REACT_APP_API_URL}/public/templates`


    useEffect(() => {
        console.log("orders", orders)
        if (orders?.data?.order_items) {
            setStatusLogin(true)
        }
    }, [orders])

    useEffect(() => {
        // Pegar parâmetros da URL (path parameters)
        if (params.userToken) {
            setUserToken(params.userToken);
        }

        if (params.userId) {
            setPlatform(params.userId);
        }
    }, [params])

    useEffect(() => {
        const fetchLoginText = async () => {
            if (!userToken || !platform) return
            console.log("userToken", userToken)
            console.log("platform", platform)
            try {
                const response = await fetch(`${API_LOGIN_TEXT_URL}?user_token=${userToken}&platform_number=${platform}`)
                const data = await response.json()
                console.log("data", data)
                setLoginText(data?.page_login_download_text || "")
            } catch (error) {
                console.error("Erro ao buscar texto de login:", error)
            }
        }
        fetchLoginText()
    }, [userToken, platform])


    const getplatform = (code) => {

        console.log("code", code)
        console.log("params", params)
        switch (code) {
            case "1":
                return "nuvemshop"
            case 1:
                return "nuvemshop"
            case "4":
                return "shopify"
            case 4:
                return "shopify"
            case "2":
                return "yampi"
            case 2:
                return "yampi"
            default:
                return "nuvemshop"
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(email, orderNumber, platform, userToken)
        dispatch({ type: "SAGA_LOGIN_ORDER", payload: { email, orderNumber, platform: getplatform(platform), userToken } });
    }

    return (
        <>
            {/*
          This example requires updating your template:
  
          ```
          <html class="h-full bg-white dark:bg-gray-900">
          <body class="h-full">
          ```
        */}
            <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
                <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                    {/* <img
                        alt="Your Company"
                        src="https://tailwindcss.com/plus-assets/img/logos/mark.svg?color=indigo&shade=600"
                        className="mx-auto h-10 w-auto dark:hidden"
                    /> */}
                    <h2 className="mt-10 text-center text-2xl/9 font-bold tracking-tight text-gray-900">
                        {t("page-downloas-acessar-pagina")}
                    </h2>
                </div>

                <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
                    <form action="#" method="POST" className="space-y-6" onSubmit={handleSubmit}>
                        <div>
                            <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                {t("page-downloas-acessar-pagina-email")}
                            </label>
                            <div className="mt-2">
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    required
                                    autoComplete="email"
                                    className="block w-full rounded-md border border-gray-300 bg-white px-3 py-1.5 text-base text-gray-900 placeholder:text-gray-400 focus:border-slate-800 focus:outline-none focus:ring-1 focus:ring-slate-800 sm:text-sm/6"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>
                        </div>

                        <div>
                            <div className="flex items-center justify-between">
                                <label htmlFor="text" className="block text-sm/6 font-medium text-gray-900">
                                    {t("page-downloas-acessar-pagina-pedido")}
                                </label>
                            </div>
                            <div className="mt-2">
                                <input
                                    id="password"
                                    name="password"
                                    type="text"
                                    required
                                    autoComplete="current-password"
                                    className="block w-full rounded-md border border-gray-300 bg-white px-3 py-1.5 text-base text-gray-900 placeholder:text-gray-400 focus:border-slate-800 focus:outline-none focus:ring-1 focus:ring-slate-800 sm:text-sm/6 "
                                    value={orderNumber}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/\D/g, '');
                                        setOrderNumber(value);
                                    }}
                                />
                            </div>
                        </div>

                        <div>
                            <button
                                type="submit"
                                className="flex w-full justify-center rounded-md bg-slate-800 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs hover:bg-slate-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-800 "
                            >
                                {orders.loading ? "Aguarde..." : "Entrar"}
                            </button>
                        </div>
                    </form>

                    {loginText && (
                        <p className="mt-10 text-center text-sm/6 text-gray-500 dark:text-gray-400">
                            {loginText}
                        </p>
                    )}
                </div>
            </div>
        </>
    )
}
